import React from "react";
import {
  Drawer,
  Button,
  Input,
  Form,
  Table,
  Row,
  Col,
  notification,
  Popconfirm,
  message,
} from "antd";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import { complaintSource } from "../../../constants/url";
import { decodedToken, stateStore } from "../../../constants/constants";

class ComplaintSource extends React.Component {
  _isMounted = false;
  state = {
    drawerIsVisible: false,
    editFormFields: [],
    tableData: {
      list: [],
      loading: true,
    },
  };

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 50,
    },
    {
      title: "User Name",
      dataIndex: "UserName",
      key: "UserName",
      align: "center",
      fixed: "left",
      width: 100,
    },
    {
      title: "System Name",
      dataIndex: "SysName",
      key: "SysName",
      align: "center",
      width: 100,
    },
    {
      title: "System Code",
      dataIndex: "SysCode",
      key: "SysCode",
      align: "center",
      width: 100,
    },
    {
      title: "User Code",
      dataIndex: "UserCode",
      key: "UserCode",
      align: "center",
      width: 100,
    },
    {
      title: "Remarks",
      dataIndex: "Remarks",
      key: "Remarks",
      align: "center",
      width: 100,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 80,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              style={{ color: "#1890ff" }}
              disabled={
                decodedToken.value.User_ID !== 1 &&
                stateStore.permissions[64] &&
                stateStore.permissions[64].UEdit === "N"
              }
              onClick={() => {
                if (
                  decodedToken.value.User_ID !== 1 &&
                  stateStore.permissions[64] &&
                  stateStore.permissions[64].UEdit === "N"
                )
                  return message.warning(
                    "No permission to perform this action!"
                  );
                const tmpList = [];
                Object.keys(item).map((key) => {
                  tmpList.push({ name: key, value: item[key] });
                  return key;
                });
                this.setState({
                  editFormFields: tmpList,
                  drawerIsVisible: true,
                });
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={() => {
                if (
                  decodedToken.value.User_ID !== 1 &&
                  stateStore.permissions[64] &&
                  stateStore.permissions[64].UDelete === "N"
                )
                  return message.warning(
                    "No permission to perform this action!"
                  );
                axiosInstance
                  .delete(complaintSource + "/" + item.SourceID)
                  .then((res) => {
                    notification.success({
                      duration: 3,
                      message: "Success",
                      description: res.data.message || "Done!",
                    });
                    this.getInitialState().then((st) => {
                      this.resetFields();
                      this.setState(st);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              {/* <a href="#">Delete</a> */}
              <DeleteOutlined
                style={{ color: "red" }}
                disabled={
                  decodedToken.value.User_ID !== 1 &&
                  stateStore.permissions[64] &&
                  stateStore.permissions[64].UDelete === "N"
                }
              />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  formRef = null;

  resetFields = () => {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  };
  onReset = () => {
    this.getInitialState().then((st) => this.setState(st));
  };

  getInitialState = async (drawerIsVisible) => {
    let state = {
      drawerIsVisible: drawerIsVisible || false,
      editFormFields: [],
      tableData: {
        list: this.state.tableData.list,
        loading: false,
      },
    };
    await axiosInstance
      .get(complaintSource)
      .then((res) => {
        if (res.data.success) {
          state.tableData.list = res.data.message.map((data, index) => {
            data.SN = index + 1;
            data.key = index;
            return data;
          });
        }
      })
      .catch(() => {});
    return state;
  };

  onCreateNew = (drawerIsVisible = false) => {
    return this.formRef
      .validateFields()
      .then(async (values) => {
        if (!this.state.editFormFields.length)
          for (let row of this.state.tableData.list)
            if (row.UserName.toLowerCase() === values.UserName.toLowerCase())
              return message.error(
                "Cannot create multiple data for the same source name !"
              );
        this.setState({
          tableData: { list: this.state.tableData.list, loading: true },
        });
        let res = null;
        res = this.state.editFormFields.length
          ? await axiosInstance
              .put(complaintSource, {
                SourceID: values.SourceID,
                SysCode: values.SysCode || values.UserCode,
                UserCode: values.UserCode,
                SysName: values.SysName || values.UserName,
                UserName: values.UserName,
                Remarks: values.Remarks || "",
              })
              .catch(() => {})
          : await axiosInstance
              .post(complaintSource, {
                SourceID: values.SourceID,
                SysCode: values.SysCode || values.UserCode,
                UserCode: values.UserCode,
                SysName: values.SysName || values.UserName,
                UserName: values.UserName,
                Remarks: values.Remarks || "",
                DateCreated: new Date(),
              })
              .catch(() => {});
        if (res && res.data.success) {
          notification.success({
            duration: 3,
            message: "Success",
            description: res.data.message,
          });
          this.getInitialState(drawerIsVisible).then((st) => {
            this.resetFields();
            this.setState(st);
          });
        } else {
          notification.error({
            message: "Fail",
            description: res.data.message,
          });
          this.setState({
            tableData: { list: this.state.tableData.list, loading: false },
          });
        }
      })
      .catch((err) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: false },
        });
      });
  };

  componentDidMount() {
    this._isMounted = true;
    if (
      decodedToken.value.User_ID !== 1 &&
      stateStore.permissions[64] &&
      stateStore.permissions[64].UView === "N"
    ) {
      message.error("You donot have permission!");
      if (stateStore.navAble)
        stateStore.navAble({
          defaultSelectedKeys: ["home"],
        });
    }
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="New Complaint Source"
          placement="right"
          closable={false}
          onClose={() => {
            this.resetFields();
            this.setState({ editFormFields: [], drawerIsVisible: false });
          }}
          visible={this.state.drawerIsVisible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                type="primary"
                style={{ borderRadius: 20 }}
              >
                {this.state.editFormFields.length ? "Save" : "Create"}
              </Button>
              {!this.state.editFormFields.length ? (
                <Button
                  style={{ borderRadius: 20 }}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button
                onClick={() => {
                  this.resetFields();
                  this.setState({
                    editFormFields: [],
                    drawerIsVisible: this.state.editFormFields.length > 0,
                  });
                }}
                style={{ borderRadius: 20 }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <Form
            requiredMark
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
          >
            <Form.Item
              key="SourceID"
              name="SourceID"
              label="Source ID"
              labelAlign="left"
              labelCol={{ span: 7 }}
              hidden
            >
              <Input disabled></Input>
            </Form.Item>
            <Form.Item
              key="SysCode"
              name="SysCode"
              label="System Code"
              labelAlign="left"
              labelCol={{ span: 7 }}
            >
              <Input disabled></Input>
            </Form.Item>
            <Form.Item
              key="UserCode"
              name="UserCode"
              label="User Code"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: false, message: "Please enter user code" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="SysName"
              name="SysName"
              label="System Name"
              labelAlign="left"
              labelCol={{ span: 7 }}
            >
              {<Input disabled></Input>}
            </Form.Item>
            <Form.Item
              key="UserName"
              name="UserName"
              label="User Name"
              labelAlign="left"
              labelCol={{ span: 7 }}
              rules={[{ required: true, message: "Please enter user name" }]}
            >
              {<Input></Input>}
            </Form.Item>
            <Form.Item
              key="Remarks"
              name="Remarks"
              label="Remarks"
              labelAlign="left"
              labelCol={{ span: 7 }}
            >
              <Input.TextArea></Input.TextArea>
            </Form.Item>
          </Form>
        </Drawer>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Complaint Source</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={() => {
                if (
                  decodedToken.value.activeKey === "employee" &&
                  decodedToken.value.User_ID !== 1 &&
                  stateStore.permissions[64] &&
                  stateStore.permissions[64].UAdd === "N"
                )
                  return message.warning(
                    "No permission to perform this action!"
                  );
                this.setState({ drawerIsVisible: true });
              }}
              style={{ borderRadius: 20 }}
              disabled={
                decodedToken.value.activeKey === "employee" &&
                decodedToken.value.User_ID !== 1 &&
                stateStore.permissions[64] &&
                stateStore.permissions[64].UAdd === "N"
              }
            >
              New
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table
              loading={this.state.tableData.loading}
              dataSource={this.state.tableData.list}
              columns={this.columns}
              scroll={{ y: window.innerHeight - 225 }}
              pagination={false}
            ></Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(ComplaintSource);
